<template>
  <v-menu left min-width="48">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item-content>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-email</v-icon>
          </template>
          <span>{{ $t('buddy.tooltip.vm') }} : {{ buddy.vmnum }}</span>
        </v-tooltip>
      </v-list-item-content>

      <v-list-item-content>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-menu v-on="on" open-on-hover offset-x
              right :disabled="!buddy.isOnCall">
              <template v-slot:activator="{ buddyMenu }">
                <v-btn icon small v-on="buddyMenu" :disabled="!buddy.isOnCall">
                  <v-icon>mdi-headphones</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item v-for="(call, idx) in buddy.calls" :key="idx" @click="spy(call)">
                  <v-list-item-title class="chanspy-menu">
                    <v-icon small>mdi-headphones</v-icon>
                    {{ buddy.exten }}
                    <v-icon>mdi-arrow-{{ call.isIncoming ? 'left' : 'right'}}</v-icon>
                    {{call.user}}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <span>{{ $t('buddy.tooltip.listen') }}</span>
        </v-tooltip>
      </v-list-item-content>

      <v-list-item-content>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="callBuddy()" v-on="on">
              <v-icon small color="primary">mdi-phone</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('buddy.tooltip.sipcall') }}</span>
        </v-tooltip>
      </v-list-item-content>

      <v-list-item-content v-if="canChatsRead && !embedded">
        <v-tooltip bottom light small>
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on" data-testid="start-chat-btn"
              v-if="canChatsRead  && !embedded" :loading="startChatLoading" @click="startChat()">
              <v-icon data-testid="start-chat-btn-icon" small color="primary">mdi-message-text</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('buddy.tooltip.startChat') }}</span>
        </v-tooltip>
      </v-list-item-content>

      <v-list-item-content>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-btn :disabled="!canWrite" icon small @click="stopWatchBuddy(buddy)" v-on="on" class="unwatch">
              <v-icon small color="warning">mdi-eye-off</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('buddy.tooltip.unwatch') }}</span>
        </v-tooltip>
      </v-list-item-content>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MixinChatRestApi from '@/mixins/chat/rest'
import EmbeddedLocalStorage from '@/api/embedded'

export default {
  name: 'actions-compact-menu',
  data () {
    return {
      startChatLoading: false
    }
  },
  props: {
    buddy: {
      type: Object,
      required: true
    }
  },
  mixins: [MixinChatRestApi],
  computed: {
    ...mapGetters({
      canWrite: 'permissions/usersWrite',
      canChatsRead: 'permissions/chatsRead',
      currentUser: 'chat/authenticatedRocketChatUser',
      directConversations: 'chat/directConversations'
    }),
    buddyChatUsername: function () {
      return this.buddy?.chatUsername
    },
    embedded () {
      return EmbeddedLocalStorage.get()
    }
  },
  methods: {
    ...mapActions({
      stopWatchBuddy: 'stopWatchBuddy',
      callNumber: 'callNumber',
      chatAuth: 'chat/auth'
    }),
    spy: function (call) {
      /* istanbul ignore next */
      this.callNumber({ number: `***${call.user}` })
    },
    callBuddy: function () {
      this.callNumber({ number: this.buddy.exten })
    },
    async startChat () {
      this.startChatLoading = true
      if (!this.currentUser) {
        await this.chatAuth()
      }
      const response = await this.createDMRoom(this.buddyChatUsername)
      const roomId = response?.data?.room?.rid
      this.startChatLoading = false
      this.$router.push({ name: 'chats', params: { roomType: 'direct', roomId: roomId } })
    }
  }
}
</script>

<style>
.vm-compact-menu .v-badge__badge {
  right: -3px;
  top: 0px;
  font-size: 10px;
  height: 16px;
  width: 16px;
}
.vm-compact-menu {
  margin-left: 10px;
}
</style>
